import React, { Fragment } from "react";

import "./AttributeItem.css";
import NoContent from "../NoContent/NoContent";
import AttributeItems from "../AttributeItems/AttributeItems";
import { required, length } from "../../util/validators";
import Input from "../../components/Form/Input/Input";
import Button from "../../components/Button/Button";
import MessageHandler from "../../components/MessageHandler/MessageHandler";

const types = [
  '" از نوع متنی می‌باشد.',
  '" از نوع نوشتاری می‌باشد.',
  '" از نوع دو حالته می‌باشد.' ,
];
const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  attributeTypeId: {
    value: 0,
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [],
  },
  unit: {
    value: "",
    valid: true,
    touched: false,
    errorMessage: "",
    validators: [],
  },
  isRequire: {
    value: "true",
    valid: true,
    touched: false,
    errorMessage: "",
    validators: [],
  },
};

class AttributeItem extends React.Component {
  constructor(props) {
    super(props);
    this.scrollAttribute = React.createRef();

    this.state = {
      postForm: POST_FORM,
      formIsValid: false,
      attributes: [], //
      noAttribute: true,
      noAttributeFormMode: true,
      isEditing: false,
      isEditSection: false,
      activeAttribute: [], //
      isItemEditSection: false,
      showMessage: false,
      attributeItems: [], //
      selectedAttributeCode: 0, //
      selectedAttributeTitle: "", //
      selectedAttributeTypeId: 0, //
      attributeCode: 0, //
      deleteAttributeTitle: "", //
    };
  }

  componentDidMount() {
    if (this.props.attributes.length !== 0) {
      this.setState({
        attributes: this.props.attributes,
        noAttribute: false,
        noAttributeFormMode: false,
        activeAttribute: new Array(this.props.attributes.length).fill(false),
      });
    }
    this.smoothScroll(this.scrollAttribute.current);
  }

  smoothScroll(target) {
    const { top } = target.getBoundingClientRect()
    window.scrollTo({
      top: top + window.pageYOffset,
      behavior: "smooth"
    });
  }

  componentDidUpdate(previousProps, previousState) {
    if (previousProps.attributes !== this.props.attributes) {
      let updatedForm = POST_FORM;
      for (const inputName in updatedForm) {
        updatedForm[inputName].value = "";
        updatedForm[inputName].valid = false;
        updatedForm[inputName].touched = false;
        updatedForm[inputName].errorMessage = "";
        if (inputName === "attributeTypeId") {
          updatedForm[inputName].value = 0;
        }
        if (inputName === "unit") {
          updatedForm[inputName].valid = true;
        }
        if (inputName === "isRequire") {
          updatedForm[inputName].value = "true";
          updatedForm[inputName].valid = true;
        }
      }

      this.setState({
        postForm: updatedForm,
        formIsValid: false,
        attributes: this.props.attributes,
        noAttribute: false,
        noAttributeFormMode: false,
        activeAttribute: new Array(this.props.attributes.length).fill(false),
      });
    }
  }

  postInputChangeHandler = (input, value) => {
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.postForm[input].validators) {
        isValid = isValid && validator(value).hasError;
        errorMessage =
          !isValid && errorMessage === "" ? validator(value).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.postForm,
        [input]: {
          ...prevState.postForm[input],
          valid: isValid,
          errorMessage: errorMessage,
          value: input === "attributeTypeId" ? parseInt(value) : value,
        },
      };

      let formIsValid = updatedForm["title"].valid;
      formIsValid = formIsValid && updatedForm["attributeTypeId"].valid;
      formIsValid = formIsValid && updatedForm["unit"].valid;
      formIsValid = formIsValid && updatedForm["isRequire"].valid;

      return {
        postForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  };

  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        postForm: {
          ...prevState.postForm,
          [input]: {
            ...prevState.postForm[input],
            touched: true,
          },
        },
      };
    });
  };

  acceptPostChangeHandler = () => {
    if (this.state.formIsValid) {
      const post = {
        title: this.state.postForm.title.value,
        unit: this.state.postForm.unit.value,
        isRequire: this.state.postForm.isRequire.value,
        attributeTypeId: this.state.postForm.attributeTypeId.value,
        code: this.state.attributeCode,
      };
      if (this.state.isEditing) {
        this.props.onEditHandler(post);
      } else {
        this.props.onAcceptModal(post);
      }
      this.setState({
        postForm: POST_FORM,
        formIsValid: false,
        isEditing: false,
        isEditSection: false,
        activeAttribute: new Array(this.props.attributes.length).fill(false),
        isItemEditSection: false,
      });
    } else {
      this.setState((prevState) => {
        let updatedForm = { ...prevState.postForm };

        for (const inputName in prevState.postForm) {
          let isValid = true;
          let errorMessage = "";
          for (const validator of prevState.postForm[inputName].validators) {
            isValid =
              isValid &&
              validator(prevState.postForm[inputName].value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.postForm[inputName].value).errorMessage
                : errorMessage;
          }
          updatedForm = {
            ...updatedForm,
            [inputName]: {
              ...updatedForm[inputName],
              valid: isValid,
              errorMessage: errorMessage,
            },
          };
        }

        return {
          postForm: updatedForm,
        };
      });
    }
  };

  newAttributeHandler = () => {
    this.setState({
      noAttributeFormMode: true,
      noAttribute: false,

      postForm: POST_FORM,
      formIsValid: false,
      isEditing: false,
      isEditSection: true,
      isItemEditSection: false,
    });
  };

  loadAttributeItems = (code) => {
    const graphqlQuery = {
      query: `
        query AttributeItems($attributeCode: Int) {
          attributeItems(attributeCode: $attributeCode){
            code
            title
            isActive
          }
        }
      `,
      variables: {
        attributeCode: code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState(
          {
            attributeItems: resData.data.attributeItems,
          },
          () => {
            // console.log(this.state.attributes);
          }
        );
      })
      .catch(this.catchError);
  };

  toggleClass(index) {
    const previousState = [...this.state.activeAttribute];
    const indexOfTrue = previousState.indexOf(true);
    previousState[indexOfTrue] = false;
    previousState[index] = true;
    if (this.state.attributes[index].attributeTypeId > 3) {
      this.loadAttributeItems(this.state.attributes[index].code);
    }
    this.setState(
      {
        selectedAttributeCode: this.state.attributes[index].code,
        selectedAttributeTitle: this.state.attributes[index].title,
        selectedAttributeTypeId: this.state.attributes[index].attributeTypeId,
        activeAttribute: previousState,
        formIsValid: true,
        isEditing: false,
        isEditSection: false,
        isItemEditSection: true,
      },
      () => {
        console.log(this.state.attributeItems);
      }
    );
  }

  toggleAttributeClass = () => {
    this.setState({
      postForm: POST_FORM,
      formIsValid: false,
      isEditing: false,
      isEditSection: true,
      activeAttribute: new Array(this.props.attributes.length).fill(false),
      isItemEditSection: false,
    });
    // this.props.onCancelEdit();
  };

  cancelPostChangeHandler = () => {
    this.setState({
      postForm: POST_FORM,
      formIsValid: false,
      isEditing: false,
      isEditSection: false,
      activeAttribute: new Array(this.props.attributes.length).fill(false),
      isItemEditSection: false,
    });
    // this.props.onCancelEdit();
  };

  addNewAttributeHandler = () => {
    this.props.newAttributeItemHandler(this.state.selectedAttributeCode);
  };

  onEditHandler = (data) => {
    const Index = this.state.attributes.findIndex((p) => p.code === data.code);
    this.setState(() => {
      const updatedForm = {
        title: {
          value: this.state.attributes[Index].title,
          valid: true,
          touched: true,
          errorMessage: "",
          validators: [required, length({ min: 2 })],
        },
        attributeTypeId: {
          value: this.state.attributes[Index].attributeTypeId,
          valid: true,
          touched: true,
          errorMessage: "",
          validators: [],
        },
        unit: {
          value: this.state.attributes[Index].unit,
          valid: true,
          touched: true,
          errorMessage: "",
          validators: [],
        },
        isRequire: {
          value: this.state.attributes[Index].isRequire ? "true" : "false",
          valid: true,
          touched: true,
          errorMessage: "",
          validators: [],
        },
      };
      return {
        postForm: updatedForm,
        formIsValid: true,
        attributeCode: data.code,
        isEditSection: true,
        isEditing: true,
      };
    });
  };

  onDeleteAttributeHandler = () => {
    this.props.onDeleteHandler({
      code: this.state.attributeCode,
    });
    this.setState({
      attributeCode: 0,
      showMessage: false,
      deleteAttributeTitle: "",
    });
  };

  onDeleteHandler = (data) => {
    const Index = this.state.attributes.findIndex((p) => p.code === data.code);
    console.log(data.code);
    this.setState({
      attributeCode: data.code,
      showMessage: true,
      deleteAttributeTitle: this.state.attributes[Index].title,
    });
  };

  onCancelAttributeHandler = () => {
    this.setState({
      attributeCode: 0,
      showMessage: false,
      deleteAttributeTitle: "",
    });
  };

  render() {
    return (
      <div ref={this.scrollAttribute}>
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelAttributeHandler}
          message={
            'آیا می‌خواهید ویژگی "' +
            this.state.deleteAttributeTitle +
            '" را پاک کنید؟'
          }
          onCancelModal={this.onCancelAttributeHandler}
          onAcceptModal={this.onDeleteAttributeHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        {this.state.noAttribute && (
          <NoContent
            firstInfoStatement="شما تا به حال هیچ ویژگی‌ تعریف نکرده‌اید"
            secondInfoStatement="برای تعیین و مقداردهی ویژگی‌های کالایی میبایست ابتدا ویژگی‌های کالایی را تعریف کنید."
            image="https://seller.digikala.com/static/files/ac21f0e6.svg"
            onClickHandler={this.newAttributeHandler}
            button="افزودن ویژگی‌های کالایی"
          />
        )}
        {!this.state.noAttribute && (
          <div className="uk-position-relative">
            <div className="mn-grid__row">
              <div className="mn-attribute-group-select">
                <div className="mn-attribute-group-select__section">
                  {this.state.noAttributeFormMode && (
                    <div className="mn-attribute-group-select__section-empty">
                      {"ویژگی‌ای‌ تعریف نشده است"}
                    </div>
                  )}
                  {!this.state.noAttributeFormMode && (
                    <div className="mn-attribute-group-select__section-fields">
                      <ul>
                        {this.props.attributes.map((data, index) => {
                          return (
                            <li key={index} className="mn-attribute-group-li">
                              <label
                                htmlFor={index}
                                className={[
                                  "mn-attribute-group-select__item mn-attribute-group-select__link",
                                  this.state.activeAttribute[index]
                                    ? "is-active"
                                    : "",
                                ].join(" ")}
                                onClick={() => {
                                  this.toggleClass(index);
                                  // this.props.onSelect(category);
                                }}
                              >
                                <input
                                  type="radio"
                                  className="uk-hidden js-category-data"
                                  data-id={index}
                                  value={data.title}
                                />
                                {data.title}
                              </label>
                              <span className="mn-attribute-group__spacer"></span>
                              <span className="mn-attribute-group-select__item_icon">
                                <i
                                  className="fa fa-pencil-square-o mn-attribute-group-select__item-edit"
                                  aria-hidden="true"
                                  onClick={this.onEditHandler.bind(this, {
                                    code: data.code,
                                  })}
                                ></i>
                                <i
                                  className="fa fa-trash-o mn-attribute-group-select__item-delete"
                                  aria-hidden="true"
                                  onClick={this.onDeleteHandler.bind(this, {
                                    code: data.code,
                                  })}
                                ></i>
                              </span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="mn-attribute-group-edit">
                <div className="mn-attribute-group-edit__section">
                  <div className="mn-grid__row mn-grid__row-space">
                    <div className="mn-grid__col mn-grid__col--sm-6 mn-grid__col--lg-10 mn-RD-profile__section-title">
                      <span className="mn-RD-profile__title">
                        {"ایجاد ویژگی کالایی"}
                      </span>
                    </div>
                    <div
                      className={[
                        "mn-grid__col mn-grid__col--sm-6 mn-grid__col--lg-2",
                        `${this.state.isEditSection && "uk-hidden"}`,
                      ].join(" ")}
                    >
                      <Button
                        design="next"
                        mode=""
                        type="submit"
                        loading={false}
                        onClick={this.toggleAttributeClass}
                      >
                        {"افزودن ویژگی "}
                        <i className="fa fa-plus" aria-hidden="true"></i>
                      </Button>
                    </div>
                  </div>

                  {this.state.isEditSection && (
                    <div className="mn-RD-profile__add-doc uk-width-1-1">
                      <span className="uk-width-1-1 uk-text-right mn-attribute-group__edit-title">
                        بارگذاری اطلاعات جدید
                      </span>
                      <form onSubmit={e => { e.preventDefault(); }}>
                        <div className="mn-attribute-group__inputs mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                          <Input
                            id="title"
                            label={"عنوان ویژگی"}
                            type="text"
                            control="input"
                            required="required"
                            onChange={this.postInputChangeHandler}
                            onBlur={this.inputBlurHandler.bind(this, "title")}
                            valid={this.state.postForm["title"].valid}
                            touched={this.state.postForm["title"].touched}
                            value={this.state.postForm["title"].value}
                            validationError={
                              !this.state.valid &&
                              this.state.postForm["title"].errorMessage
                            }
                          />
                        </div>
                        <div className="mn-attribute-group__inputs mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                          <Input
                            id="unit"
                            label={"واحد"}
                            type="text"
                            control="input"
                            required=""
                            onChange={this.postInputChangeHandler}
                            onBlur={this.inputBlurHandler.bind(this, "unit")}
                            valid={this.state.postForm["unit"].valid}
                            touched={this.state.postForm["unit"].touched}
                            value={this.state.postForm["unit"].value}
                            validationError={
                              !this.state.valid &&
                              this.state.postForm["unit"].errorMessage
                            }
                          />
                        </div>
                        <div className="c-ui-form__col c-ui-form__col--xs-12 c-ui-form__col--wrap-xs">
                          <label className="c-ui-form__label">
                            ویژگی اجباری:
                          </label>
                          <div className="c-mega-campaigns-join-list__container-filters-statues c-ui-product-config-search__radio-input-container">
                            <label className="c-ui-filters__radio-label c-ui-filters__radio-label--form c-ui-form__col--4">
                              <input
                                id="isRequire"
                                className="c-ui-filters__radio"
                                type="radio"
                                name="isRequire"
                                value={true}
                                onChange={(e) =>
                                  this.postInputChangeHandler(
                                    e.target.id,
                                    e.target.value
                                  )
                                }
                                onBlur={this.inputBlurHandler.bind(
                                  this,
                                  "isRequire"
                                )}
                                validationError={
                                  !this.state.valid &&
                                  this.state.postForm["isRequire"].errorMessage
                                }
                                checked={
                                  this.state.postForm["isRequire"].value ===
                                  "true"
                                }
                              />
                              <span
                                className="c-ui-filters__radio-option c-ui-filters__radio-option--form"
                                style={{ minWidth: "62px" }}
                              >
                                اجباری
                              </span>
                            </label>
                            <label className="c-ui-filters__radio-label c-ui-filters__radio-label--form c-ui-form__col--4">
                              <input
                                id="isRequire"
                                className="c-ui-filters__radio"
                                type="radio"
                                name="isRequire"
                                value={false}
                                onChange={(e) =>
                                  this.postInputChangeHandler(
                                    e.target.id,
                                    e.target.value
                                  )
                                }
                                onBlur={this.inputBlurHandler.bind(
                                  this,
                                  "isRequire"
                                )}
                                validationError={
                                  !this.state.valid &&
                                  this.state.postForm["isRequire"].errorMessage
                                }
                                checked={
                                  this.state.postForm["isRequire"].value ===
                                  "false"
                                }
                              />
                              <span
                                className="c-ui-filters__radio-option c-ui-filters__radio-option--form"
                                style={{ minWidth: "62px" }}
                              >
                                اختیاری
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="c-ui-form__col c-ui-form__col--xs-12 c-ui-form__col--wrap-xs">
                          <label className="c-ui-form__label">
                            نوع ویژگی‌:
                          </label>
                          <div className="c-mega-campaigns-join-list__container-filters-statues c-ui-product-config-search__radio-input-container">
                            <label className="c-ui-filters__radio-label c-ui-filters__radio-label--form c-ui-form__col--4">
                              <input
                                id="attributeTypeId"
                                className="c-ui-filters__radio"
                                type="radio"
                                name="search[active]"
                                value="1"
                                onChange={(e) =>
                                  this.postInputChangeHandler(
                                    e.target.id,
                                    e.target.value
                                  )
                                }
                                onBlur={this.inputBlurHandler.bind(
                                  this,
                                  "attributeTypeId"
                                )}
                                validationError={
                                  !this.state.valid &&
                                  this.state.postForm["attributeTypeId"]
                                    .errorMessage
                                }
                                checked={
                                  this.state.postForm["attributeTypeId"]
                                    .value === 1
                                }
                              />
                              <span
                                className="c-ui-filters__radio-option c-ui-filters__radio-option--form"
                                style={{ minWidth: "30px" }}
                              >
                                متن کوتاه
                              </span>
                            </label>
                            <label className="c-ui-filters__radio-label c-ui-filters__radio-label--form c-ui-form__col--4">
                              <input
                                id="attributeTypeId"
                                className="c-ui-filters__radio"
                                type="radio"
                                name="search[active]"
                                value="2"
                                onChange={(e) =>
                                  this.postInputChangeHandler(
                                    e.target.id,
                                    e.target.value
                                  )
                                }
                                onBlur={this.inputBlurHandler.bind(
                                  this,
                                  "attributeTypeId"
                                )}
                                validationError={
                                  !this.state.valid &&
                                  this.state.postForm["attributeTypeId"]
                                    .errorMessage
                                }
                                checked={
                                  this.state.postForm["attributeTypeId"]
                                    .value === 2
                                }
                              />
                              <span
                                className="c-ui-filters__radio-option c-ui-filters__radio-option--form"
                                style={{ minWidth: "30px" }}
                              >
                                نوشتاری
                              </span>
                            </label>
                            <label className="c-ui-filters__radio-label c-ui-filters__radio-label--form c-ui-form__col--4">
                              <input
                                id="attributeTypeId"
                                className="c-ui-filters__radio"
                                type="radio"
                                name="search[active]"
                                value="3"
                                onChange={(e) =>
                                  this.postInputChangeHandler(
                                    e.target.id,
                                    e.target.value
                                  )
                                }
                                onBlur={this.inputBlurHandler.bind(
                                  this,
                                  "attributeTypeId"
                                )}
                                validationError={
                                  !this.state.valid &&
                                  this.state.postForm["attributeTypeId"]
                                    .errorMessage
                                }
                                checked={
                                  this.state.postForm["attributeTypeId"]
                                    .value === 3
                                }
                              />
                              <span
                                className="c-ui-filters__radio-option c-ui-filters__radio-option--form"
                                style={{ minWidth: "30px" }}
                              >
                                دارد/ندارد
                              </span>
                            </label>
                            <label className="c-ui-filters__radio-label c-ui-filters__radio-label--form c-ui-form__col--4">
                              <input
                                id="attributeTypeId"
                                className="c-ui-filters__radio"
                                type="radio"
                                name="search[active]"
                                value="4"
                                onChange={(e) =>
                                  this.postInputChangeHandler(
                                    e.target.id,
                                    e.target.value
                                  )
                                }
                                onBlur={this.inputBlurHandler.bind(
                                  this,
                                  "attributeTypeId"
                                )}
                                validationError={
                                  !this.state.valid &&
                                  this.state.postForm["attributeTypeId"]
                                    .errorMessage
                                }
                                checked={
                                  this.state.postForm["attributeTypeId"]
                                    .value === 4
                                }
                              /> 
                              <span
                                className="c-ui-filters__radio-option c-ui-filters__radio-option--form"
                                style={{ minWidth: "30px" }}
                              >
                                چندگزینه‌ای
                              </span>
                            </label>
                            <label className="c-ui-filters__radio-label c-ui-filters__radio-label--form c-ui-form__col--4">
                              <input
                                id="attributeTypeId"
                                className="c-ui-filters__radio"
                                type="radio"
                                name="search[active]"
                                value="5"
                                onChange={(e) =>
                                  this.postInputChangeHandler(
                                    e.target.id,
                                    e.target.value
                                  )
                                }
                                onBlur={this.inputBlurHandler.bind(
                                  this,
                                  "attributeTypeId"
                                )}
                                validationError={
                                  !this.state.valid &&
                                  this.state.postForm["attributeTypeId"]
                                    .errorMessage
                                }
                                checked={
                                  this.state.postForm["attributeTypeId"]
                                    .value === 5
                                }
                              />
                              <span
                                className="c-ui-filters__radio-option c-ui-filters__radio-option--form"
                                style={{ minWidth: "30px" }}
                              >
                                چندمقداری
                              </span>
                            </label>
                          </div>
                        </div>
                      </form>
                      <div className="uk-flex uk-flex-right uk-flex-bottom">
                        <Button
                          design="next"
                          mode=""
                          type="submit"
                          loading={false}
                          onClick={this.acceptPostChangeHandler}
                        >
                          {this.state.isEditing ? "ویرایش ویژگی" : "ثبت ویژگی"}
                        </Button>
                        <Button
                          design="reset"
                          mode=""
                          type="submit"
                          loading={false}
                          onClick={this.cancelPostChangeHandler}
                        >
                          {}
                        </Button>
                      </div>
                    </div>
                  )}
                  {!this.state.isEditSection && (
                    <Fragment>
                      {!this.state.isItemEditSection && (
                        <NoContent
                          firstInfoStatement="برای درج ویژگی ابتدا یک ویژگی را تعریف کنید."
                          secondInfoStatement="برای ویرایش ویژگی‌ کالایی میبایست ابتدا یک ویژگی‌ را انتخاب کنید."
                          image=""
                          // onClickHandler={this.newAttributeHandler}
                          empty={true}
                          button=""
                        />
                      )}
                      {/* // selectedAttributeCode */}
                      {this.state.isItemEditSection &&
                        this.state.selectedAttributeTypeId > 3 && (
                          <AttributeItems
                            attributeItems={this.state.attributeItems}
                            selectedAttributeCode={
                              this.state.selectedAttributeCode
                            }
                            token={this.props.token}
                          />
                        )}

                      {this.state.isItemEditSection &&
                        this.state.selectedAttributeTypeId < 4 && (
                          <NoContent
                            firstInfoStatement={
                              'ویژگی انتخابی "' +
                              this.state.selectedAttributeTitle +
                              types[this.state.selectedAttributeTypeId-1]
                            }
                            secondInfoStatement="برای تغییر حالت ویژگی، نسبت به ویرایش ویژگی‌ کالایی انتخابی اقدام کنید."
                            image=""
                            // onClickHandler={this.addNewAttributeHandler}
                            empty={true}
                            button=""
                            //   نمایش حالت ویژگی ، اگر سلکت بود تمایش مقادیر اتریبیوتآیتم
                          />
                        )}
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AttributeItem;
 